module.exports = __webpack_public_path__ + "449ea1cbc6ad04c9e1b7bf72de2afc3d.png";